"use client";
export function ApplicatorEducationalContent() {
  return (
    <section
      id="applicators-education"
      className="py-24 border-t border-border bg-foreground/5 dark:bg-card/30"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 space-y-12">
        <div>
          <h2 className="font-serif text-3xl md:text-4xl font-light mb-6 tracking-tight">
            Why Hire a Certified Microcement & Plaster Applicator?
          </h2>
          <div className="prose prose-stone dark:prose-invert max-w-none leading-relaxed">
            <p>
              Professional microcement and specialty plaster finishes require
              precise substrate preparation, controlled layering, and calibrated
              curing to achieve seamless durability. Certified Concretta
              applicators follow standardized application protocols that reduce
              cracking risk, ensure bonding, and produce consistent
              industrial-modern aesthetics.
            </p>
            <ul>
              <li>
                Moisture & substrate assessment prevents premature failure.
              </li>
              <li>
                Multi-coat system creates a dense, stain-resistant micro-layer.
              </li>
              <li>
                Color & finish control for design-intent fidelity (matte, satin,
                satin-polished).
              </li>
              <li>
                Fast project turnaround versus full-depth concrete or tile
                removal.
              </li>
              <li>
                Low VOC, thin build (2–3mm) retrofit friendly over existing
                surfaces.
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h3 className="font-serif text-2xl md:text-3xl font-light mb-4 tracking-tight">
            Common Microcement & Plaster Applications
          </h3>
          <div className="grid md:grid-cols-3 gap-6 text-sm text-muted-foreground">
            <div className="space-y-2">
              <p className="font-medium text-foreground">Residential</p>
              <ul className="space-y-1">
                <li>Kitchen countertops</li>
                <li>Seamless showers</li>
                <li>Heated floors</li>
                <li>Fireplace surrounds</li>
              </ul>
            </div>
            <div className="space-y-2">
              <p className="font-medium text-foreground">Commercial</p>
              <ul className="space-y-1">
                <li>Retail floors</li>
                <li>Hospitality walls</li>
                <li>Restaurant bars</li>
                <li>Office lobbies</li>
              </ul>
            </div>
            <div className="space-y-2">
              <p className="font-medium text-foreground">Specialty</p>
              <ul className="space-y-1">
                <li>Acoustic plaster features</li>
                <li>Custom pigment systems</li>
                <li>Exterior protected zones</li>
                <li>Pool & spa surrounds*</li>
              </ul>
            </div>
          </div>
          <p className="mt-4 text-xs text-muted-foreground">
            *Requires additional waterproofing system specification.
          </p>
        </div>
        <div>
          <h3 className="font-serif text-2xl md:text-3xl font-light mb-4 tracking-tight">
            How to Choose the Right Applicator
          </h3>
          <ol className="list-decimal pl-6 space-y-2 text-sm text-muted-foreground">
            <li>
              Request project photos: assess consistency in finish texture &
              tonal control.
            </li>
            <li>
              Verify substrate prep methodology (grinding, priming, mesh
              reinforcement where needed).
            </li>
            <li>
              Confirm moisture tolerance & sealing system for wet or exterior
              zones.
            </li>
            <li>
              Align on sheen level, color batch control, and edge termination
              details.
            </li>
            <li>
              Obtain maintenance guidance (neutral cleaners, re-seal intervals).
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}
